module.exports = __webpack_public_path__ + "static/3-b3cd989b610645d257c569065ac5be88.png";